import React from 'react'
import InventoriesList from './list'

const Inventories = () => {
    return (
        <>
            <InventoriesList/>
        </>

    )
}

export default Inventories